import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useQuery } from 'react-query';
import { Messages } from 'primereact/messages';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { generatePath, Link} from 'react-router-dom';
import { ActionIcon, ActionsWrapper, ApproverLink } from '../DataTable/common';
import { getUserPlaces } from '../../services/user';
import { REPORT_DETAIL } from '../../config/routes';
import { Place } from '../../services/model';

const Wrapper = styled.div`
  max-width: 700px;
  margin: 32px auto;
`;

function UserDashboard() {
  const { data, isFetching, error } = useQuery('userPlaces', getUserPlaces);
  const messages = useRef<Messages>(null);

  useEffect(() => {
    if (error) {
      messages.current?.show({ severity: 'error', summary: 'An error has occurred while loading data!', sticky: true });
    }
  }, [error]);

  /**
   * Used to generate the Link to open the Report page with details
   *
   * @param {Place} rowData list of user place(s)
   */
  const reportLinkBodyTemplate = (rowData: Place) => (
    <ActionsWrapper>
      <Link to={generatePath(REPORT_DETAIL, { placeCode: rowData.code })}>
        <ActionIcon className="pi pi-search" aria-label="Detail" />
      </Link>
    </ActionsWrapper>
  );

  /**
   * Used to generate the Link to open the Targets page with change(s) for approval
   * @param {Place} rowData list of user place(s)
   * @return {ApproverLink} Link
   */
  const approverLinkBodyTemplate = (rowData: Place) => {
    let link;

    //place have a approval
    if (rowData.isApproval) {
      link = (
        <>
          <ApproverLink to={`report/${rowData.code}?action=approvement`}>
            <i className="pi pi-exclamation-circle" />
            <span>Pending changes for approval</span>
          </ApproverLink>
        </>
      );
    }

    return link;
  };

  return (
    <Wrapper>
      <Messages ref={messages} />
      <DataTable value={data} loading={isFetching} paginator rows={15} rowHover tableStyle={{ width: '100%' }}>
        <Column header="Place Name" field="name" sortable />
        <Column header="Place Code" field="code" sortable />
        <Column header="" body={approverLinkBodyTemplate}></Column>
        <Column header="" body={reportLinkBodyTemplate} />
      </DataTable>
    </Wrapper>
  );
}

export default UserDashboard;
